import ThreadEditorVM from 'components/editors/thread/thread';
import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Observable, Subscribable } from 'knockout';
import { ActivityFormEditorConfig } from 'managers/topic/form';
import ActivityVM from './activity';
import './mobileEditorsToolbar.html';
import './mobileEditorsToolbar.scss';

export interface TaskActivityMobileEditorsToolbarConfig {
    activity: ActivityVM
}

@injectable()
export default class TaskActivityMobileEditorsToolbar {
    mainForm: Observable<ThreadEditorVM | undefined>
    mainFormConfig: Subscribable<ActivityFormEditorConfig | undefined>

    secondaryFormConfig: Subscribable<ActivityFormEditorConfig | undefined>

    toAwait: Subscribable<Array<string>>

    constructor(
        @inject(wccModules.componentConfig) { activity }: TaskActivityMobileEditorsToolbarConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.mainForm = activity.mainForm;
        this.mainFormConfig = activity.mainFormConfig

        this.secondaryFormConfig = activity.secondaryFormConfig;

        this.toAwait = ko.pureComputed(() => {
            const result = new Array<string>();

            const mainComponentId = this.mainFormConfig()?.componentId;
            const secondaryComponentId = this.secondaryFormConfig()?.componentId;

            if (mainComponentId != undefined)
                result.push(mainComponentId);

            if (secondaryComponentId != undefined)
                result.push(secondaryComponentId);

            return result;
        });

        ko.applyBindingsToNode(info.element, {
            'visible': this.mainFormConfig.isNotNull(),

            'css': {
                'task-activity__mobile-editors-toolbar': true
            }
        });
    }
}